module.exports = __webpack_public_path__ + "img/cogir.bebb06b4.webp";